import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-invoice-category';
const API_DETAIL = (id: number) => `/p-crm-invoice-category/${id}`;

export interface PCrmInvoiceCategory {
  id: number;
  pic_descr?: string;
}

export const usePCrmInvoiceCategorys = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<PCrmInvoiceCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    pCrmInvoiceCategorys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePCrmInvoiceCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<PCrmInvoiceCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    pCrmInvoiceCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};
